import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tag, MessageCircle, Send } from "lucide-react";

const DEALS = [
  {
    title: "Daily Common Number Pack",
    tag: "Free",
    desc: "Get today's admin-verified common numbers, house digits and ending digits — updated before every F/R draw.",
  },
  {
    title: "Weekend Predictor Report",
    tag: "Popular",
    desc: "A weekend analysis PDF summarising 7-day trends, hot pairs and target picks for both rounds.",
  },
  {
    title: "Priority WhatsApp Alerts",
    tag: "VIP",
    desc: "Receive F/R and S/R results on WhatsApp within seconds of the counter announcement.",
  },
];

export default function Deal() {
  return (
    <>
      <PageHeader title="Deals & Offers" subtitle="Perks for Official Morning Teer fans" />
      <div className="max-w-xl mx-auto w-full px-4 pb-10 space-y-3">
        {DEALS.map((d, i) => (
          <Card key={i} className="p-5 border-slate-200 hover:shadow-md transition-shadow">
            <div className="flex items-start gap-3">
              <span className="inline-flex h-11 w-11 rounded-xl bg-rose-100 text-rose-600 items-center justify-center shrink-0">
                <Tag className="h-5 w-5" />
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-bold text-slate-900">{d.title}</h3>
                  <span className="inline-flex text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">
                    {d.tag}
                  </span>
                </div>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed">{d.desc}</p>
              </div>
            </div>
          </Card>
        ))}
        <Card className="p-5 border-slate-200 bg-gradient-to-br from-[#0a1428] to-slate-900 text-white">
          <h3 className="font-heading font-bold text-lg">Want to claim a deal?</h3>
          <p className="text-sm text-slate-300 mt-1">
            Reach out on WhatsApp or Telegram and we'll help you get set up.
          </p>
          <div className="flex gap-2 mt-4">
            <Button
              asChild
              className="flex-1 rounded-full bg-[#25D366] hover:bg-[#20b358] text-white"
              data-testid="deal-whatsapp"
            >
              <a href="https://wa.me/916009660070" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="flex-1 rounded-full border-sky-400 text-sky-400 hover:bg-sky-400/10 hover:text-sky-300"
              data-testid="deal-telegram"
            >
              <a href="https://t.me/morningteertoday" target="_blank" rel="noopener noreferrer">
                <Send className="h-4 w-4 mr-2" /> Telegram
              </a>
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
}
